export default __webpack_public_path__ + "static/media/Reciept_Icon.18ca47d6.svg";